<template>
  <div :style="getElementStyle" class="eb-select">
    <!-- Below code is for Before Field View -->

    <div v-if="!isDefalutPos">
      <div style="display: flex; align-items: unset">
        <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
        <label for="text" style="white-space: nowrap; margin-right: 5px">
          {{ data.label }}
          <span
            v-if="data.validations.required"
            style="color: red; font-weight: bold; margin-right: 5px"
          >
            *
          </span>
          <span>
            <i class="el-icon-copy-document" v-if="!isDataTableField" @click="copyDocument"></i>
          </span>
          <span v-if="data.description" style="margin-right: 5px">
            <i class="el-icon-info" :title="data.description"></i>
          </span>
        </label>
        <span>
          <el-select
            :style="getStyle"
            v-model="selectedValue"
            :placeholder="data.placeholder"
            v-if="!isList"
          >
            <el-option
              v-for="(option, index) of options"
              :value="option.value"
              :key="index"
              :label="option.name"
            ></el-option>
          </el-select>
          <el-select
            v-if="isList"
            :style="getStyle"
            v-model="selectedValue"
            :placeholder="data.placeholder"
          >
            <el-option
              v-for="(option, index) of options"
              :value="option.value"
              :key="index"
              :label="option.name"
            ></el-option>
          </el-select>
        </span>
      </div>
      <div v-if="isActive || isDataTableField" class="setting-icon" style="padding-left: 10px">
        <i class="el-icon-s-tools" @click="openSettings"></i>
      </div>
    </div>
    <!-- Below code is for Top Field View -->

    <el-row align="middle" v-else>
      <el-col
        v-if="!isInDataTable"
        :span="showLabel && !isDefalutPos ? 4 : data.description ? 20 : 24"
        class="label-size bottom-space"
        :style="computedStyles"
      >
        <span style="display: flex">
          <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
          <label for="text">
            {{ data.label }}
            <span v-if="data.validations.required" style="color: red; font-weight: bold">*</span>
            <i class="el-icon-copy-document" v-if="!isDataTableField" @click="copyDocument"></i>
            <span>
              <el-popover
                v-if="data.description"
                placement="top-start"
                trigger="hover"
                :content="data.description"
              >
                <i class="el-icon-info" slot="reference"></i>
              </el-popover>
            </span>
          </label>
        </span>
      </el-col>
      <el-row v-if="isActive || isDataTableField" class="setting-icon" style="padding-left: 10px">
        <i class="el-icon-s-tools" @click="openSettings"></i>
      </el-row>
      <el-col :span="showLabel && !isDefalutPos ? 12 : 24">
        <el-select
          :style="getStyle"
          v-model="selectedValue"
          :placeholder="data.placeholder"
          v-if="!isList"
        >
          <el-option
            v-for="(option, index) of options"
            :value="option.value"
            :key="index"
            :label="option.name"
          ></el-option>
        </el-select>
        <el-select
          v-if="isList"
          :style="getStyle"
          v-model="selectedValue"
          :placeholder="data.placeholder"
        >
          <el-option
            v-for="(option, index) of options"
            :value="option.value"
            :key="index"
            :label="option.name"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { fetchGlobalVariableById } from '@/repo/globalVariables';
  export default {
    components: {},
    props: ['data', 'value', 'isActive', 'isDataTableField', 'isInDataTable', 'isIconRequired'],
    computed: {
      ...mapGetters('globalVariables', ['getGlobalVariableById']),
      computedStyles() {
        const styles = {};
        styles.display = 'flex';
        if (this.data?.styles?.labelAlignments) {
          styles.justifyContent = this.data.styles.labelAlignments;
        }
        return styles;
      },
      selectedValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      getStyle() {
        return `height:${this.data.height - 30}px`;
      },
      getElementStyle() {
        let borderStyle = '';
        if (this.data.styles) {
          let type = this.data.styles.border_type ? this.data.styles.border_type : 'solid';
          let size = this.data.styles.border_size ? this.data.styles.border_size + 'px' : '0px';
          let color = this.data.styles.border_color ? this.data.styles.border_color : '';
          let font_size =
            this.data.styles && this.data.styles.font && this.data.styles.font.font_size
              ? this.data.styles.font.font_size
              : '';
          let bold =
            this.data.styles &&
            this.data.styles.font &&
            (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
              ? 'bold'
              : '';
          let italic =
            this.data.styles &&
            this.data.styles.font &&
            (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
              ? 'italic'
              : '';

          borderStyle = 'border:' + type + ' ' + ' ' + size + ' ' + color;

          borderStyle += ';';
          borderStyle += this.data.styles.background
            ? `background: ${this.data.styles.background}`
            : '';
          borderStyle += ';';
          borderStyle += this.data.styles.label_color
            ? `color: ${this.data.styles.label_color}`
            : '';
          borderStyle += ';';
          borderStyle += 'font-size:' + font_size + 'px;';
          if (bold) {
            borderStyle += 'font-weight:' + bold + ';';
          }
          if (italic) {
            borderStyle += 'font-style:' + italic + ';';
          }
          borderStyle += this.data.styles.label_color
            ? `color: ${this.data.styles.label_color}`
            : '';
        }
        return borderStyle;
      },
      //gayatri starts
      isDefalutPos() {
        if (this.data.styles && this.data.styles.labelStyle == 'right') {
          return false;
        } else {
          return true;
        }
      },
      //end
    },
    data() {
      return {
        validations: [],
        options: [],
        isList: false,
        isDefalutPosq: true,
        showLabel: true,
      };
    },
    mounted() {
      if (this.data.styles && this.data.styles.labelStyle) {
        if (this.data.styles.labelStyle == 'hide') {
          this.showLabel = false;
        }
        if (this.data.styles.labelStyle == 'right') {
          this.isDefalutPos = false;
        }
      }
      this.options = this.data.list_data || [];
      if (this.data.is_global_variable && this.data.global_variable_id) {
        this.setGlobalVariableData();
      }
    },
    methods: {
      copyDocument() {
        this.$emit('copy-document', this.data.key);
      },
      async setGlobalVariableData() {
        let params = {
          id: this.data.global_variable_id,
        };
        let globalVariable = await fetchGlobalVariableById(params);
        if (globalVariable) {
          if (globalVariable.input_type == 'LIST') {
            this.isList = true;
            this.options = globalVariable.list_data;
            this.data.is_list = true;
          } else {
            this.data.is_list = false;
          }
        }
      },
      openSettings() {
        this.$emit('settings');
      },
    },
    watch: {
      'data.options': {
        handler() {
          this.options = this.data.list_data || [];
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-select {
    width: 100% !important;

    .el-input,
    .el-input__inner {
      height: inherit !important;
    }
  }
</style>
